<template>
       <!-- Add Account Modal -->
    <div class="modal worli-Bets-Modal" id="acc-open-model" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog" role="document">
            <div class="modal-content wallet_edit_stake_modal">
                <div class="modal-header modal_cmn_header">
                    <h5 class="modal-title">{{$t('add-account', 'Add account')}}</h5>
                </div>
                <div class="modal-body add_bank_acc_form">
                    <div class="p-0">
                        <div class="acc_login_form_sec" v-if="paymentMethodList">
                            <label>{{ $t('payment-method', 'Payment Method') }}</label>
                            <select @change="onPaymentMethodChange" v-model="paymentMethodId" class="form-select form-control">
                                <option disabled value="null">---{{ $t('select-payment-method', 'Select Payment Method') }}---</option>
                                <option v-for="(item, index) in paymentMethodList" :key="index" :value="item.id" >{{ item.method_name }}</option>
                            </select>
                        </div>
                            
                        <template v-if="type === 'bank'">
                            <div class="acc-login-form-sec" v-if="filteredBankList">
                                <div class="select-payment-list">
                                    <div class="dropdown bank-dropdown">
                                        <button class="bank-dropdown-input" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                         <span>{{  selectedBank ? selectedBank : $t('select-bank-name', 'Select Bank Name') }}</span>
                                        <img src="@/assets/images/arow-down.webp" alt="">
                                        </button>
                                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                            <div class="search-input">
                                                <input type="search" v-model="searchBank" class="form-control" placeholder="Search Banks...">
                                            </div>
                                            <li v-for="(item, index) in filteredBankList" :key="index" v-if="filteredBankList && filteredBankList.length">
                                                <a class="dropdown-item" @click="selectBank(item)">{{ item.bank_name }}</a>
                                            </li>
                                            <li v-else>
                                                <a class="dropdown-item">{{$t('no-data-found','No data found')}}</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <p v-if="v$.accountForm.bankId.$error" class="wallet-error">{{ $t('please-select-bank-name', 'Please Select Bank Name') }}.</p>
                            </div>
                            <div class="acc-login-form-sec">
                                <input type="text" v-model="accountForm.holderName" :placeholder="$t('enter-account-holder-name', 'Enter Account Holder Name*')" class="form-control" @input="accountForm.holderName = accountForm.holderName.replace(/^\s+/, '')">
                                <template v-if="v$.accountForm.holderName.$error">
                                    <div v-if="v$.accountForm.holderName.required.$invalid" class="wallet-error" for="nameInput">{{ $t('account-holder-name-is-required', 'Account holder name is required') }}</div>
                                    <span v-else-if="v$.accountForm.holderName.minLength.$invalid || v$.accountForm.holderName.maxLength.$invalid" class="wallet-error" for="nameInput">
                                        {{ $t('min-characters','Account holder name must be 3-100 characters.') }}
                                    </span>
                                    <span v-if="v$.accountForm.holderName.alphaName.$invalid" class="wallet-error" for="nameInput">
                                        {{ $t('only-letters','Must contain only alphabets, spaces, dots, or hyphens.') }}
                                    </span>
                                </template>
                            </div>
                            <div class="acc-login-form-sec">
                                <input v-model="accountForm.accountNumber" type="tel"  :placeholder="$t('enter-ac-Number', 'Enter A/C Number*')" class="form-control" @input="accountForm.accountNumber = accountForm.accountNumber.replace(/^\s+/, '')">
                                <template v-if="v$.accountForm.accountNumber.$error">
                                    <div v-if="v$.accountForm.accountNumber.required.$invalid" class="wallet-error" for="nameInput">{{ $t('ac-number-is-required', 'Account Number is required') }}.</div>
                                    <span v-if="v$.accountForm.accountNumber.accountNoValidator.$invalid" class="wallet-error" for="nameInput">
                                        {{ $t('invalid-account-number','Account number must be valid numeric value between 9 to 18 digits.') }}
                                    </span>
                                </template>
                            </div>
                            <div class="acc-login-form-sec">
                                <input v-model="accountForm.ifscCode" type="text" maxlength="11" @input="accountForm.ifscCode = accountForm.ifscCode.toUpperCase(), accountForm.ifscCode = accountForm.ifscCode.replace(/^\s+/, '')" :placeholder="$t('enter-ifsc-code', 'Enter IFSC Code*')" class="form-control">
                                 <template v-if="v$.accountForm.ifscCode.$error">
                                    <div v-if="v$.accountForm.ifscCode.required.$invalid" id="ifscCodeInput-error" class="wallet-error" for="ifscCodeInput">{{ $t('ifsc-code-is-required', 'IFSC code is required') }}.</div>
                                    <span v-if="v$.accountForm.ifscCode.ifscValidator.$invalid" class="wallet-error" for="nameInput">
                                        {{ $t('invalid-ifsc','IFSC code should be 11 Alphanumeric Characters') }}
                                    </span>
                                 </template>
                            </div>
                        </template>
                        <template v-if="type === 'upi' || type === 'wallet'">
                            <div class="acc-login-form-sec">
                                <input v-model="accountForm.holderName"  type="text" class="form-control" :placeholder="$t('enter-account-holder-name', 'Enter Account Holder Name*')" @input="accountForm.holderName = accountForm.holderName.replace(/^\s+/, '')"/>
                                <template v-if="v$.accountForm.holderName.$error">
                                    <div v-if="v$.accountForm.holderName.required.$invalid" class="wallet-error" for="nameInput">{{ $t('account-holder-name-is-required', 'Account holder name is required') }}</div>
                                    <span v-else-if="v$.accountForm.holderName.minLength.$invalid || v$.accountForm.holderName.maxLength.$invalid" class="wallet-error" for="nameInput">
                                        {{ $t('min-characters','Account holder name must be 3-100 characters.') }}
                                    </span>
                                    <span v-if="v$.accountForm.holderName.alphaName.$invalid" class="wallet-error" for="nameInput">
                                        {{ $t('only-letters','Must contain only alphabets, spaces, dots, or hyphens.') }}
                                    </span>
                                </template>
                            </div>

                            <template v-if="type === 'upi'">
                                <div class="acc-login-form-sec">
                                    <input v-model="accountForm.upiId" class="form-control profit-input" type="text" :placeholder="$t('enter-upi-id', 'Enter UPI ID')" @input="accountForm.upiId = accountForm.upiId.replace(/^\s+/, '')">
                                    <template v-if="v$.accountForm.upiId.$error">
                                        <span class="wallet-error" v-if="accountForm.upiId && v$.accountForm.upiId.minLength?.$invalid || v$.accountForm.upiId.maxLength.$invalid">{{ $t('upi-length','UPI ID must be 5 to 50 characters.') }}</span>
                                        <span class="wallet-error" v-if="accountForm.upiId && v$.accountForm.upiId.upiValidator?.$invalid">{{ $t('upi-format','Must be in the format of name@bank.') }}</span>
                                    </template>
                                </div>
                            </template>

                            <template v-if="type === 'wallet'">
                                <div class="acc-login-form-sec">
                                    <input v-model="accountForm.walletId" class="form-control profit-input" type="text" :placeholder="$t('enter-wallet-id', 'Enter wallet ID*')" @input="accountForm.walletId = accountForm.walletId.replace(/^\s+/, '')">
                                    <template v-if="v$.accountForm.walletId.$error">
                                        <div class="wallet-error" v-if="v$.accountForm.walletId.required.$invalid">{{ $t('wallet-id-is-required', 'Wallet ID is required') }}</div>
                                        <span class="wallet-error" v-if="v$.accountForm.walletId.minLength.$invalid || v$.accountForm.walletId.maxLength.$invalid">{{ $t('upi-length','Wallet ID must be 8 to 20 characters.') }}</span>
                                        <span class="wallet-error" v-if="v$.accountForm.walletId.walletValidator.$invalid">{{ $t('wallet-format','Must contain only letters, numbers, @, hyphens, or underscores.') }}</span>
                                    </template>
                                </div>
                            </template>

                            <div class="acc-login-form-sec">
                                <div class="utr_proof_cl" v-if="!previewImageUtr">
                                    <div class="form-group utr_file_input_grp">
                                        <input type="file" class="form-control" ref="qrImage" @change="fileUpdateFunc" accept=".png, .webp, .jpg, .jpeg" multiple />
                                        <span class="info-sec-icon">
                                            <img src="@/assets/images/info-icon.svg" alt="info-icon" loading="lazy">
                                            <div class="info-list add_acc_info_tooltips">
                                                <ul>
                                                    <li>1. {{ $t('upload-a-screenshot-of-a-valid-qr-code-to-proceed', 'Upload a screenshot of a valid QR code to proceed') }}.</li>
                                                    <li>2. {{ $t('if-qr-code-is-not-detected-exchange-will-not-be-responsible-for-the-losses', 'If QR code is not detected, Exchange will not be responsible for the losses') }}.</li>
                                                </ul>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                                <div class="number-header col-12 thm-heading d-inline-block" v-if="previewImageUtr">
                                    <h5 class="mb-2 info-sec team-list-wet">{{ $t('qr-code', 'QR Code') }}</h5>
                                    <div class="fileList"><img class="fileList-img" :src="previewImageUtr" alt="file-list"/><button
                                            class="add-utr-again" @click="clearPaymentSlip()">
                                            <img src="@/assets/images/cross-icon.webp" alt="cross-icon" loading="lazy">
                                        </button>
                                        <div class="fileList-loader" v-if="loading">
                                            <div class="loader">
                                                <div class="sk-fading-circle">
                                                    <div class="sk-circle1 sk-circle"></div>
                                                    <div class="sk-circle2 sk-circle"></div>
                                                    <div class="sk-circle3 sk-circle"></div>
                                                    <div class="sk-circle4 sk-circle"></div>
                                                    <div class="sk-circle5 sk-circle"></div>
                                                    <div class="sk-circle6 sk-circle"></div>
                                                    <div class="sk-circle7 sk-circle"></div>
                                                    <div class="sk-circle8 sk-circle"></div>
                                                    <div class="sk-circle9 sk-circle"></div>
                                                    <div class="sk-circle10 sk-circle"></div>
                                                    <div class="sk-circle11 sk-circle"></div>
                                                    <div class="sk-circle12 sk-circle"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-if="type">
                           <div class="acc-login-form-sec">
                            <!-- <label for="nameInput">{{ $t('withdrawal-password', 'Withdrawal Password') }}<span class="star_req">*</span></label> -->
                               <div class="fill_con">
                                   <input :type="passwordFieldType"  v-model="accountForm.withdrawal_password" @input="accountForm.withdrawal_password = $helper.sanitizeDetails('withdrawPassword', accountForm.withdrawal_password.replace(/\s/g, ''), 200)"  
                                   :placeholder="$t('enter-withdrawal-password', 'Enter Withdrawal Password*')" class="form-control password-input" />
                                    <div class="showHide-pass">
                                        <i @click="togglePasswordVisibility('passwordField')" class="fa-solid" :class="passwordFieldType === 'password' ? 'fa-eye-slash' : 'fa-eye'"></i>
                                    </div>
                               </div>
                                <div v-if="v$.accountForm.withdrawal_password.$error" class="wallet-error" for="nameInput">{{ $t('withdraw-password-is-required', 'Withdraw password is required') }}</div>
                           </div>
                        </template>
                    </div>
                    <div class="header-but info-footer w-100 stake_footer_sec">
                        <button type="button" class="thm-but thm-bor-but w-50" data-bs-dismiss="modal" @click="clearError()">{{$t('cancel','Cancel')}}</button>
                        <a class="thm-but w-50" @click="addAccountServiceCall()">{{$t('save','Save')}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required, minLength, maxLength, helpers } from '@vuelidate/validators';
import {addAccount} from '../services/withdrawAccountDetails';

const alphaName = helpers.withMessage(
  'Must contain only alphabets, spaces, dots, or hyphens.',
  (value) => {
    if (value === null || value === undefined || value === '') return true
    const s = String(value)
    return /^[A-Za-z .-]+$/.test(s)
  }
)
const accountNoValidator = helpers.withMessage(
  'Account number must be valid numeric value between 9 to 18 digits.',
  (value) => {
    if (!value) return true
    return /^[0-9]{9,18}$/.test(String(value))
  }
)
const ifscValidator = helpers.withMessage(
  "Invalid IFSC Code format. It should be 11 alphanumeric characters like.",
  (value) => {
    if (!value) return true;
    return /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9]{11}$/.test(String(value))
  }
)
const upiValidator = helpers.withMessage(
  "Must be in the format of 'name@bank.'",
  (value) => {
    if (!value) return true
    return /^[A-Za-z0-9]+@[A-Za-z0-9]+$/.test(String(value))
  }
)
const walletValidator = helpers.withMessage(
  'Must contain only letters, numbers, hyphens, or underscores.',
  (value) => {
    if (value === null || value === undefined || value === '') return true
    return /^[A-Za-z0-9_@-]+$/.test(String(value))
  }
)

export default {
    name: 'AddBankAccount',
    inject:['walletConfig'],
    setup() {
		return { v$: useVuelidate() }
	},
    props:{
        getAccountDetailList: Function,
        paymentMethodList: Array
    },
    data() {
        return {
            loading: false,
            paymentMethodId: null,
            type: null,
            bankDetailsList: null,
            accountForm: {
				bankId: null,
				holderName: '',
				accountNumber: '',
				ifscCode: '',
				upiId: '',
				walletId: '',
				file: null,
                withdrawal_password: null
			},
            passwordFieldType: 'password',
            searchBank:null,
            selectedBank:null,
            previewImageUtr: null,
            paymentMethod: null
        }
    },
    computed: {
        filteredBankList() {            
            if(this.searchBank) {
                const searchTermLower = this.searchBank?.toLowerCase();
                return this.bankDetailsList.filter(item => item.bank_name?.toLowerCase().includes(searchTermLower));
            }
            return this.bankDetailsList
        }
    },
    validations() {
        return {
            accountForm: {
                bankId: this.type === 'bank' ? { required } : {},
                holderName: { 
                    required,
                    minLength: minLength(3),
                    maxLength: maxLength(100),
                    alphaName
                },
                accountNumber: this.type === 'bank' ? { 
                    required,
                    accountNoValidator
                } : {},
                ifscCode: this.type === 'bank' ? { 
                    required,
                    ifscValidator
                } : {},
                upiId: this.type === 'upi' ? {
                    minLength: minLength(5),
                    maxLength: maxLength(50),
                    upiValidator
                } : {},
                walletId: this.type === 'wallet' ? { 
                    required,
                    minLength: minLength(8),
                    maxLength: maxLength(20),
                    walletValidator 
                } : {},
                withdrawal_password: { required },

            }
        };
    },
    created() {
        this.bankDetailsList = this.walletConfig?.bank_list
        document.addEventListener('click', this.handleClickOutside);
    },
    methods: {
        handleClickOutside() {
            this.searchBank = null;
        },
        clearPaymentSlip() {
            this.previewImageUtr = null;
            this.accountForm.file = undefined;
            this.loading = false;
        },
        selectBank(item){
            this.accountForm.bankId = item.id
            this.selectedBank = item.bank_name
            this.searchBank = ''
        },
        onPaymentMethodChange() {
            this.clearData();
            const selectedItem = this.paymentMethodList.find(item => item.id === this.paymentMethodId);
            this.getPaymentMethodItem(selectedItem);
            this.paymentMethod = selectedItem
        },
        clearData(){
            this.accountForm = {
				bankId: null,
				holderName: '',
				accountNumber: '',
				ifscCode: '',
				upiId: '',
				walletId: '',
				file: null,
                withdrawal_password: null
			}
            if(this.$refs?.qrImage){
                this.$refs.qrImage.value = null
            }
            this.errors = {};
            this.selectedBank = null;
            this.searchBank=null,
            this.v$.$reset();
            this.previewImg = null;
        },
        getPaymentMethodItem(item) {
            this.type = item?.method_type;
            this.accountForm.paymentMethodId = item.id;
		    this.accountForm.paymentTypeName = item.name;
        },
        async addAccountServiceCall() { 
            this.v$.$touch()
            if (this.v$.$error) {
                return
            }
            if(this.type === 'upi' && this.accountForm.upiId == '' && this.accountForm.file == null){
                this.$errorToast('At least one field is required UPI ID or QR code.')
                return false;
            }
            let response = await addAccount(this.paymentMethod, this.type, this.accountForm, null)
            if(response){
                this.$helper.closeModal('acc-open-model')
                this.clearError(); 
                this.getAccountDetailList()
            }
        },
        async fileUpdateFunc(event) {
            this.accountForm.file = event.target.files[0];
           
            if (!this.accountForm.file.type.startsWith('image/')) {
                event.target.value = "";
                this.accountForm.file = null;
                this.$errorToast('Invalid file type. Only JPG, JPEG, PNG, and WEBP image formats are allowed, and file size must be under 5 MB.');
                return;
            }
            const maxSize = 5 * 1024 * 1024;
            if (this.accountForm.file.size > maxSize) {
                event.target.value = "";
                this.accountForm.file = null;
                this.$errorToast('Invalid file type. Only JPG, JPEG, PNG, and WEBP image formats are allowed, and file size must be under 5 MB.');
                return;
            }
            this.previewImageUtr = URL.createObjectURL(this.accountForm.file);
        },
        clearError() {
            this.accountForm = {
				bankId: null,
				holderName: '',
				accountNumber: '',
				ifscCode: '',
				upiId: '',
				walletId: '',
				file: null
			},
            this.previewImageUtr = null,
            this.type = null,
            this.paymentMethodId = null,
            this.errors = {};
            this.selectedBank = null;
            this.searchBank=null,
            this.passwordFieldType = 'password'
            this.v$.$reset();
        },
        togglePasswordVisibility() {
            this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
        }
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    },
}
</script>